import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { finalize, Subject } from 'rxjs';
import { AuthService } from '../../../core/auth/auth.service';

@Component({
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LoginComponent {
  private readonly formBuilder = inject(FormBuilder);
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);


  showPassword: boolean;

  loginForm: FormGroup;

  loading$: Subject<boolean | null> = new Subject();

  constructor() {
    const formBuilder = this.formBuilder;

    this.showPassword = false;
    this.loginForm = formBuilder.group({
      email: [null, [Validators.required, Validators.email]],
      password: [null, [Validators.required]]
    });
  }

  onSubmit(): void {
    this.loading$.next(true);

    this.authService.login(this.loginForm.value).pipe(
      finalize(() => {
        this.loading$.next(false);
      })
    ).subscribe(() => {
      this.router.navigate(['/']);
    });
  }

}
